import { BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";

 const actionEnums = [
     BaseActionEnum.Refresh,
     BaseActionEnum.SelectAll,
     BaseActionEnum.RemoveAll,
     BaseActionEnum.Favorite,
];

export const actionItems = getActionMenuItems(actionEnums);        
